import { ILabel } from '@websolutespa/bom-core';
import { getInitializer, LlmInstance, LlmOptions } from '@websolutespa/bom-mixer-llm';
import defaultLabels from '../../../web/store/label.json';
import { llmPlugin } from './plugin';

export * from './blocks';
export * from './components';
export * from './llm';
export * from './mock';
export * from './plugin';

const initializer_ = getInitializer('llmDefault', [llmPlugin]);

type Options = LlmOptions & {
  labels?: ILabel[];
};

const initializer = (props: Options): (LlmInstance & {
  dispose: () => void;
}) | undefined => {
  props.labels = defaultLabels;
  return initializer_(props);
};

if (typeof window !== 'undefined') {
  (window as any)['llmDefault'] = initializer;
}

export type LlmPlugin = typeof initializer;
